/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

import { getApi } from 'lib/axios';
import { BASE_URL } from 'utils/const';

import { enqueueSnackbar } from './notificationSlice';

/**
 * ユーザー満足度評価を全件取得する
 */
export const fetchAllSatisfactionRatings = createAsyncThunk(
  'satisfactionRatings/fetchAllSatisfactionRatings',
  async (data, { dispatch }) => {
    const param = {
      per_page: data.rowsPerPage,
      page: data.page,
      user_name: data.userName,
      rating: data.rating,
      trigger_type: data.triggerType,
      has_comment: data.hasComment,
      created_at_from: data.created_at_from,
      created_at_to: data.created_at_to,
    };

    try {
      const res = await getApi(`${BASE_URL}/satisfaction_ratings`, param);

      return {
        data: res.data,
        total: res.meta.total,
        ratingList: res.meta.rating_list,
        triggerTypeList: res.meta.trigger_type_list,
      };
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: 'エラーが発生しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }),
      );

      throw error;
    }
  },
);

const satisfactionRatingsAdapter = createEntityAdapter({
  selectId: (e) => e.rating_id,
});

export const satisfactionRatingSlice = createSlice({
  name: 'satisfactionRatings',
  initialState: satisfactionRatingsAdapter.getInitialState({
    loading: true,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllSatisfactionRatings.fulfilled, (state, action) => {
      satisfactionRatingsAdapter.setAll(state, action.payload.data);
      state.loading = false;
    });
    builder.addCase(fetchAllSatisfactionRatings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllSatisfactionRatings.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const satisfactionRatingSelectors = satisfactionRatingsAdapter.getSelectors(
  (state) => state.satisfactionRatings,
);

export default satisfactionRatingSlice.reducer;
